import React,{Component} from 'react';

import { Button } from 'react-bootstrap';

import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';


class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const {value,name} = event.target;

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit() {
        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <SelectWrap
                    values={this.props.countries}
                    label="Country:"
                    name="cc"
                    onChange={this.handleFieldChange}
                    value={this.state.cc}
                />
                <SelectWrap
                    values={['special-offers.online','special-promotions.online']}
                    label="Domain:"
                    name="domain"
                    onChange={this.handleFieldChange}
                    value={this.state.domain}
                />
                <FieldGroup
                    type="date"
                    name="dateFrom"
                    label="Date From:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateFrom}
                />
                <FieldGroup
                    type="date"
                    name="dateTo"
                    label="Date To:"
                    onChange={this.handleFieldChange}
                    value={this.state.dateTo}
                />
                <Button type="submit">Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/Users/components/Filters/index.js